import { Loader2, RotateCcw, X } from "lucide-react";

export const SwatchEditor = ({ swatches, loading, onChange, onReset }) => {
  const update = (i, target) => onChange(swatches.map((s, idx) => (idx === i ? { ...s, target } : s)));
  const remove = (i) => onChange(swatches.filter((_, idx) => idx !== i));

  return (
    <div data-testid="swatch-editor">
      <div className="flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#52525B]">Colour swatches</span>
        <button
          type="button"
          onClick={onReset}
          data-testid="swatch-reset-btn"
          className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.15em] font-bold text-[#52525B] hover:text-[#ED5A24] transition-colors duration-200"
        >
          <RotateCcw className="w-3 h-3" /> Reset
        </button>
      </div>
      {loading ? (
        <div className="mt-3 flex items-center gap-2 text-xs text-[#52525B]" data-testid="swatch-loading">
          <Loader2 className="w-3.5 h-3.5 animate-spin" /> Reading colours…
        </div>
      ) : (
        <div className="mt-3 grid grid-cols-2 gap-2" data-testid="swatch-list">
          {swatches.map((s, i) => (
            <SwatchChip key={s.source} swatch={s} index={i} onPick={update} onRemove={remove} canRemove={swatches.length > 1} />
          ))}
        </div>
      )}
      <p className="text-xs text-[#52525B] mt-2 leading-relaxed">
        Recommended from your logo. Click a colour to change it; removed colours merge into the closest one.
      </p>
    </div>
  );
};

const SwatchChip = ({ swatch, index, onPick, onRemove, canRemove }) => {
  const changed = swatch.target !== swatch.source;
  return (
    <div
      className="group flex items-center gap-2 bg-white border border-black/10 px-2 py-1.5 transition-colors duration-200 hover:border-[#ED5A24]"
      data-testid={`swatch-${index}`}
    >
      <label className="relative w-7 h-7 shrink-0 cursor-pointer border border-black/15" style={{ background: swatch.target }}>
        {changed && (
          <span className="absolute -bottom-1 -right-1 w-3 h-3 border border-white" style={{ background: swatch.source }} />
        )}
        <input
          type="color"
          value={swatch.target}
          onChange={(e) => onPick(index, e.target.value)}
          data-testid={`swatch-color-input-${index}`}
          className="absolute inset-0 opacity-0 cursor-pointer"
        />
      </label>
      <div className="min-w-0 flex-1">
        <div className="text-[11px] font-mono font-bold uppercase" data-testid={`swatch-hex-${index}`}>{swatch.target}</div>
        <div className="text-[10px] text-[#52525B]">{swatch.coverage}%</div>
      </div>
      {canRemove && (
        <button
          type="button"
          onClick={() => onRemove(index)}
          data-testid={`swatch-remove-${index}`}
          className="text-[#52525B] hover:text-[#ED5A24] opacity-60 group-hover:opacity-100 transition-opacity duration-200"
          aria-label="Remove colour"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};
